import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const PatentApplicationSchema = z.object({
  patentApplicationId: z.string(),
  patentFamilyId: z.string(),
  jurisdiction: z.string().length(2),
  applicationNumber: z.string(),
  publicationNumber: z.string().nullable(),
  filingDate: z.coerce.date().nullable(),
  publicationDate: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type PatentApplication = z.infer<typeof PatentApplicationSchema>;

export const PatentApplicationsSchema = z.array(PatentApplicationSchema);

export type PatentApplications = z.infer<typeof PatentApplicationsSchema>;

export const PatentApplicationsQuerySchema =
  createOffsetPaginationRequestQuerySchema(
    z.enum([
      'jurisdiction',
      'filingDate',
      'publicationDate',
      'createdAt',
      'updatedAt',
    ]),
  ).merge(
    z.object({
      patentApplicationIds: commaDelimitedList(
        PrimaryKeySchema.array(),
      ).optional(),
      patentFamilyIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
      jurisdictions: commaDelimitedList(
        z.string().length(2).array(),
      ).optional(),
      applicationNumberLike: z.string().optional(),
    }),
  );

export type PatentApplicationsQuery = z.infer<
  typeof PatentApplicationsQuerySchema
>;

export const CreatePatentApplicationSchema = PatentApplicationSchema.pick({
  patentFamilyId: true,
  jurisdiction: true,
  applicationNumber: true,
  publicationNumber: true,
  filingDate: true,
  publicationDate: true,
});

export type CreatePatentApplication = z.infer<
  typeof CreatePatentApplicationSchema
>;
